<!--
 * @Description: 缺陷清单
-->
<template>
  <CockpitDialog
    title="缺陷清单"
    class="left-480px top-200px text-white !text-opacity-80"
    @close="close"
  >
    <div class="defect-manage-w h-full">
      <el-row>
        <el-col :span="24">
          <el-input
            size="small"
            placeholder="请输入缺陷登录编号"
            v-model="search.keyword"
            class="w-200px mr-5px"
            clearable
          ></el-input>
          <el-select
            v-model="search.status"
            placeholder="是否关联"
            filterable
            clearable
            class="mr-5px"
            size="mini"
            popper-class="visualization-select-popper"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button size="small" class="ml-10px" type="primary" @click="searchList"
            >搜索</el-button
          >
          <el-button
            size="small"
            class="ml-10px"
            type="primary"
            @click="toAdd"
            :loading="btnLoading"
            >新增</el-button
          >
        </el-col>
      </el-row>
      <el-table
        ref="table"
        :data="dataList"
        :row-key="(row) => row.id"
        :highlight-current-row="true"
        class="mt-10px"
        :height="`calc(100% - 100px)`"
        v-loading="tableLoading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
      >
        <el-table-column type="index" label="序号" width="55"> </el-table-column>
        <el-table-column
          prop="defect_login_code"
          label="缺陷登录编号"
          width="130"
        ></el-table-column>
        <el-table-column prop="defect_desc" label="缺陷描述" width="240"></el-table-column>
        <el-table-column label="KKS编码" prop="kks_code" width="150">
          <template #default="{ row }">
            <span
              v-if="row.isModelRelation"
              class="cursor-pointer text-blue-500"
              @click="findNodeByCode(row.kks_code, true)"
            >
              {{ row.kks_code }}
            </span>
            <span v-else>{{ row.kks_code }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="report_department" label="报告人部门" width="120"></el-table-column>
        <el-table-column prop="reporter" label="报告人" width="80"></el-table-column>
        <el-table-column prop="bgrqort_data" label="报告日期" width="160"></el-table-column>
        <el-table-column prop="response" label="响应等级" width="80"></el-table-column>
        <el-table-column prop="defect_state" label="缺陷状态" width="80"></el-table-column>
        <!-- <el-table-column prop="sets_desc" label="机组描述"></el-table-column>
        <el-table-column prop="speciality_desc" label="专业描述"></el-table-column>
        <el-table-column prop="work_type_desc" label="工作类型描述" width="110"></el-table-column> -->
        <el-table-column label="操作" width="80" fixed="right">
          <template #default="{ row }">
            <el-button
              type="defult"
              class="cursor-pointer !text-blue-500 !h-24px !leading-h-24px"
              size="mini"
              @click.stop="viewDetail(row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="w-full text-right text-white">
        <el-pagination
          class="r mt-10px"
          @size-change="searchList"
          @current-change="currentChange"
          :current-page.sync="page.pageNo"
          :page-sizes="pageSizeAll"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="page.total"
          background
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </div>
    <DefectForm v-if="isShowForm" class="w-800px h-500px" @refresh="refresh" />
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import handoverService from '../../../../service/HandoverService'
import { token1, token2, token3 } from '../constant'
import DefectForm from './defectForm'

const baseUrl = Wiz.GetModuleServer()
export default {
  components: {
    CockpitDialog,
    DefectForm,
  },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
    },
    /* 是否设置勾选添加的最值 */
    isSetMaxSelected: {
      type: Boolean,
      default: false,
    },
    /* 设置可以勾选添加的最大值 */
    maxCount: Number,
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageSizeAll: [15, 30, 50, 100],
      tableLoading: false,
      search: {
        keyword: '',
        status: '',
      },
      statusList: [
        { label: '已关联模型', value: '1' },
        { label: '未关联模型', value: '2' },
      ],
      dataList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      copyNodePtr: 0, // 暂存的节点
      copyMat: 0, // 暂存的材质
      defaultCameraInfo: null, // 默认视角参数
      isShowForm: false, // 是否显示新增缺陷表单
      btnLoading: false, // 新增按钮loading
      account: '',
      clickInList: false, // 模型的选中是否是通过列表的kks点击
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    // 驾驶舱配置
    modelSetting() {
      return Wiz.globalSettings.dynamicModules.modules['visualization-tongre-vulkan'].config
    },
    newDefectUrl() {
      return this.modelSetting.defectManageConfig?.newDefectUrl || null
    },
  },
  async mounted() {
    this.getDefaultList()
    this.account = Wiz.AuthHooks.GetUserInfo().profile.name
    this.defaultCameraInfo = await this.player.Native.Camera.currentParam() // 获取默认相机信息
    this.player.Native.ModelTree.EventSelectItemChanged.connect((e) => {
      if (!this.clickInList) {
        console.log(e, '点选模型了')
        this.getDefectLoginCode(e?.code)
      }
      this.clickInList = false
    })
  },
  methods: {
    // 根据kks_code获取缺陷登录编号
    getDefectLoginCode(kksCode) {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_login_limit/V1.0?token=${token1}&kks_code=${
          kksCode || ''
        }`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          this.defectLoginCode = res.data.data[0].defect_login_code
          this.search.keyword = this.defectLoginCode
          this.getDefaultList()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取缺陷列表
    async getDefaultList() {
      this.tableLoading = true
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_login/V1.0.1.1.1?token=${token1}&defect_login_code=${this.search.keyword}&pageNo=${this.page.pageNo}&pageSize=${this.page.pageSize}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          this.tableLoading = false
          if (res && res.data.code === 200) {
            this.dataList = []
            this.dataList = res.data.data.items
            this.page.total = res.data.data.totalCount
            const codes = this.dataList.map((item) => {
              return item.kks_code
            })
            this.getBindCodes(codes)
          }
        })
        .catch((err) => {
          this.tableLoading = false
          console.log(err)
        })
    },
    // 获取已绑定的缺陷
    async getBindCodes(codes) {
      const data = {
        codes: codes || [],
      }
      axios({
        method: 'POST',
        url: `${baseUrl}/openapi/query/work_ticket_is_relation/V1.0?token=${token2}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
        data,
      })
        .then((res) => {
          console.log(res, '获取的已绑定的缺陷列表数据')
          const list = res.data.data.map((item) => {
            return item.code
          })
          if (codes) {
            this.dataList = this.dataList.map((item) => {
              if (list.includes(item.kks_code)) {
                item.isModelRelation = true
              }
              return item
            })
          } else {
            this.getFilterList(list)
          }

          console.log(this.dataList, 'this.dataList')
        })
        .catch((err) => {
          this.tableLoading = false
          console.log(err)
        })
    },
    // 获取筛选的列表数据
    async getFilterList(codes) {
      const data = {
        defect_login_code: this.search.keyword,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      }
      if (this.search.status === '1') {
        data.kks_codes = codes
      } else if (this.search.status === '2') {
        data.nokks_codes = codes
      }
      axios({
        method: 'POST',
        url: `${baseUrl}/openapi/query/uf_defect_login_kks/V1.0?token=${token3}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
        data,
      })
        .then((res) => {
          console.log(res, '筛选缺陷列表数据')
          if (this.search.status === '1') {
            this.dataList = res.data.data.items.map((item) => {
              item.isModelRelation = true
              return item
            })
          } else if (this.search.status === '2') {
            this.dataList = res.data.data.items
          }
          this.page.total = res.data.data.totalCount
        })
        .catch((err) => {
          this.tableLoading = false
          console.log(err)
        })
    },
    viewDetail(row) {
      this.$emit('openDetail', row)
    },
    searchList() {
      this.page.pageNo = 1
      if (this.search.status) {
        this.getBindCodes()
        // this.getFilterList()
      } else {
        this.getDefaultList()
      }
    },
    currentChange() {
      if (this.search.status) {
        this.getBindCodes()
        // this.getFilterList()
      } else {
        this.getDefaultList()
      }
    },
    // 恢复上一个node的颜色
    async resetColor() {
      if (this.copyNodePtr !== 0) {
        await this.player.Native.NodeProxy.setNodeMaterial(this.copyNodePtr, this.copyMat)
      }
    },
    // 恢复相机
    async resetCamera() {
      await this.player.Native.Camera.moveTo(
        this.defaultCameraInfo.eye,
        this.defaultCameraInfo.target,
        this.defaultCameraInfo.up,
        1
      )
    },
    // 通过kks码定位模型设备区域
    async findNodeByCode(code, clickInList) {
      this.clickInList = clickInList
      await this.resetColor()
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(decodeURIComponent(code))
      if (codeInfo && codeInfo.nodePtr) {
        // 场景是以node的形式加载的
        console.log('codeInfo.nodePtr', codeInfo.nodePtr)
        await this.player.Native.Camera.moveToCode(decodeURIComponent(code), 1) // 相机跳转
        await this.player.Native.ModelTree.setSelectItem(codeInfo.item) // 模型选中
        this.copyNodePtr = codeInfo.nodePtr
        const mat = await this.player.Native.NodeProxy.getNodeMaterial(codeInfo.nodePtr) // 材质的指针句柄
        this.copyMat = await this.player.Native.NodeProxy.copyMaterial(mat) // 复制材质,暂存材质
        await this.player.Native.NodeProxy.setMaterialDiffuse(mat, 1253923583)
      } else {
        await this.resetCamera()
      }
    },
    // 新增缺陷
    toAdd() {
      // this.isShowForm = true
      this.btnLoading = true
      axios({
        method: 'POST',
        url: `${this.newDefectUrl}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
        data: {
          account: this.account,
        },
      })
        .then((res) => {
          console.log(res, '获取单点登录地址')
          this.btnLoading = false
          if (res) {
            window.open(res, '_blank')
          }
        })
        .catch((err) => {
          this.btnLoading = false
          console.log(err)
        })
    },
    // 刷新
    refresh(val) {
      this.isShowForm = false
    },
    close() {
      this.$emit('refresh', false)
    },
  },
  async beforeDestroy() {
    await this.resetColor()
    this.copyNodePtr = 0
    this.copyMat = 0
    await this.resetCamera()
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table__body .el-table__row.hover-row > td.el-table__cell {
    background-color: transparent !important;
  }
}
</style>
